import {Component, OnInit, HostListener} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {DeviceService, EventTrackerService, HttpService, LogService, TypeShowLogInConsole} from '@app/core';
import {AdtraceService} from '@app/core/ad-trace/adtrace.service';
import {IndicatorService} from '@app/shared';
import {PlanTypeItems, ISubscription, DirectDebitStatus} from '../subscription.model';

import {SubscriptionService} from '../subscription.service';
import {TokenService} from "@app/core/token/token.service";
import {AppParametersService} from "@app/core/token/app-parameters.service";
import {NotificationService} from "@app/shared/notification/notification.service";
import {Location, PlatformLocation} from "@angular/common";
import {Subscription} from "rxjs";
import {filter} from "rxjs/operators";
import {SubscriptionStatus} from "@app/app/subscription/subscriptionStatusResponse";

@Component({
  selector: 'navaar-subscriptions',
  templateUrl: './subscriptions-plans.component.html',
  styleUrls: ['./subscriptions-plans.component.scss', './../style.scss']
})
export class SubscriptionsPlansComponent implements OnInit {
  @HostListener('window:popstate', ['$event'])
  onPopState(event: Event) {
    event.preventDefault();
    this.onBackKeyButton();
  }

  private readonly CB_SUBSCRIPTION = 'CB_subscription_NotValidate';
  public productIdSeleted: any;
  public subscriptionPlansSimple: Array<ISubscription>;
  public subscriptionPlansRecurring: Array<ISubscription>;
  public isMarkets: boolean = false;
  public marketsInProccess: boolean = false;
  public marketsStatusText: string;
  public marketsInstaled: boolean = true;
  private TypeMarkets: string;
  private TypeMarketsfa: string;
  public isLogin: boolean = false;
  public hasRecurring: boolean = false;
  public isLoadingBtn: boolean = false;
  public selectedRecurring: ISubscription | null = null;
  public subscription: Subscription = new Subscription();
  public hasAlreadySubscription: boolean | null = null;

  constructor(
    private readonly notificationService: NotificationService,
    private readonly subscriptionService: SubscriptionService,
    public readonly appParametersService: AppParametersService,
    private readonly log: LogService,
    private readonly adtrace: AdtraceService,
    private readonly eventTracker: EventTrackerService,
    public readonly device: DeviceService,
    private readonly indicator: IndicatorService,
    private readonly router: Router,
    private readonly http: HttpService,
    private readonly tokenService: TokenService,
    private readonly platformLocation: PlatformLocation,
    private readonly location: Location,
  ) {
    this.indicator.hide();
  }

  public ngOnInit() {
    this.tokenService.isLogin$.subscribe(z => {
      this.isLogin = z;
      this.hasAlreadySubscription = null;
      if (z) {
        this.subscriptionService
          .checkUserSubscriptionStatus()
          .subscribe((c: SubscriptionStatus | null) => {
            if (c === null || c.isUnlimitedSubscription === false) {
              this.getPlans();
            } else if (c.isUnlimitedSubscription === true) {
              this.hasAlreadySubscription = true;
            }
          });
      } else {
        this.getPlans();
      }
    });
    if (this.device.isMarkets()) {
      this.TypeMarkets = this.device.typeMyket();
      this.TypeMarketsfa = this.device.isCaffebazar() ? 'کافه بازار' : 'مایکت';
      this.log.logger(`checkUnConsume${this.TypeMarkets} on subscription page START >>`);
      (window as any).Android.checkUnConsumeCafebazaar();
      if (localStorage.getItem(this.CB_SUBSCRIPTION) !== null) {
        this.marketsStatusText = 'شما خرید تایید نشده دارید . لطفا منتظر بمانید...';

        this.http.checkMarketsToken(JSON.parse(localStorage.getItem(this.CB_SUBSCRIPTION)))
          .subscribe((res: any) => {
            this.log.logger(`validate ${this.TypeMarkets} purchase in subscription history storage`);
            this.log.logger(res);
            this.device.setMarketsNewStatus(10, 'subscription');
            localStorage.removeItem(this.CB_SUBSCRIPTION);
          }, err => {
            this.log.logger(`validate ${this.TypeMarkets} purchase in subscription history storage errrrror`);
            this.log.logger(err);
            if (err.status == 500) {
              localStorage.removeItem(this.CB_SUBSCRIPTION);
              this.device.setMarketsNewStatus(0, 'subscription');
            }
          }, () => {
          });
      }
      this.device.marketsSubscriptionStatus$.subscribe(data => {
        this.log.logger(`sucscribe ${this.TypeMarkets}SubscriptionStatus$ >>>>>`);
        this.log.logger(data);
        if (data == 1) {
          this.marketsStatusText = `در حال دریافت اطلاعات از ${this.TypeMarketsfa} ...`;
        } else if (data == 6) {
          this.marketsStatusText = 'در حال ثبت طرح اشتراک خریداری شده ...';
        } else if (data == 10) {

          // this.disableBtn = false;
          this.marketsInProccess = false;
          this.marketsStatusText = 'طرح اشتراک شما با موفقیت ثبت شد';
          let item = this.subscriptionPlansSimple.find(c => c.product.productId == this.productIdSeleted);
          this.adtrace.Adtrace(item.product.price);
          this.router.navigateByUrl('/profile').then();
          this.device.setMarketsNewStatus(0, 'subscription');
        } else if (data == 20) {
          this.marketsInstaled = false;
          this.marketsStatusText = `در این نسخه از اپلیکیشن نوار، خرید تنها از طریق پرداخت درون‌برنامه‌ای ${this.TypeMarketsfa} امکان‌پذیر است.`;
        } else if (data == 21) {
          // cancel
          this.marketsStatusText = '';
        }
      });
      this.indicator.hide()
    }
  }

  private getPlans() {
    this.subscriptionService.getNewSubscriptionPlans().subscribe(data => {
        this.hasRecurring = data.some(c => c.planType === PlanTypeItems.recurring);
        this.subscriptionPlansSimple = data.filter(x => x.planType === PlanTypeItems.simple);
        this.subscriptionPlansRecurring = data.filter(x => x.planType === PlanTypeItems.recurring);
        this.log.logger('subscription plans Simple = ');
        this.log.logger(this.subscriptionPlansSimple, TypeShowLogInConsole.table);
        this.log.logger('subscription plans Recurring = ');
        this.log.logger(this.subscriptionPlansRecurring, TypeShowLogInConsole.table);
        this.hasAlreadySubscription = false;
      },
      err => console.log(err),
      () => {
      });
  }

  public onClickItem(product: ISubscription): void {
    if (!this.isLogin) {
      this.device.goTologinPageNative(this.router.url);
      return;
    }
    this.productIdSeleted = product.product.productId;
    let _productId = product.product.productId;
    this.log.logger(`product id selected : ${_productId}`);
    if (this.device.isMarkets()) {
      this.log.logger(`is${this.TypeMarkets} and call startPurchase${this.TypeMarkets}() >> subscription')`);
      if (!this.marketsInstaled) {
        return;
      }
      this.device.setMarketsNewStatus(1, 'subscription');
      // call in-app purchase native
      (window as any).Android.startPurchaseCafeBazzar(product.product.sku, _productId + '@subscription');
    } else {
      this.device.purchaseBook(_productId);
    }
    if (!this.device.isMarkets())
      this.indicator.showHude(true);
  }

  public onClickRecurringItem(product: ISubscription) {
    if (!this.isLogin) {
      this.device.goTologinPageNative(this.router.url);
      return;
    }
    this.productIdSeleted = product.product.productId;
    this.selectedRecurring = product;
    this.platformLocation.pushState(null, null, location.href + '#modalOpened');
  }

  public activeRecurring() {
    this.isLoadingBtn = true;
    this.subscriptionService.processWithDirectDebit(this.productIdSeleted).subscribe(x => {
      this.isLoadingBtn = false;
      switch (x.status) {
        case DirectDebitStatus.CreateContract:
          this.device.openLinkInBrowser(x.data, false);
          /*
          *
          * 0: در این حالت نیاز هست که کاربر را به لینک موجود در فیلد دیتا در یک پنجره جدید بروزر هدایت کنیم. تا روند را خودش طی کند. لازم به ذکر هست در مواردی که کلاینت برای ما محدودیت دارد باید آن را در نظر بگیریم. مثلا وقتی حالت pwa نصب شده است خوب نمیتوانیم در پنجره جدید باز کینم و در همان گنجره باز شود یاد در حالت ذره بین باید توسط deeplink ذره بین در window جدید ذره بین باز بشه و یا موارد دیگر...

          * */
          break;
        case DirectDebitStatus.PurchaseDone:
          this.router.navigate(['/profile']).then();
          break;
        case DirectDebitStatus.ShowError:
          this.notificationService.setNotification({
            show: true,
            text: x.data,
            type: 'error'
          })
          break;
      }
    }, err => {
      if (err?.error?.message)
        this.notificationService.setNotification({
          show: true,
          text: err?.error?.message ?? 'مشکلی در عملیات بوجود آمده است',
          type: 'error'
        })
      this.isLoadingBtn = false;
    })
  }

  public navigateToHowUse() {
    this.device.openLinkInBrowser("https://blog.navaar.ir/terms/#subscription");
  }

  public onBackKeyButton() {
    if (this.location.path(true).includes('#modalOpened')) {
      this.location.back();
    }
    this.selectedRecurring = this.productIdSeleted = null;
  }
}

